module.exports = __webpack_public_path__ + "img/gaststaett.8d33ae26.png";